import {EmitterConfigV3, upgradeConfig} from '@pixi/particle-emitter';
import {Texture} from 'pixi.js';

import {Position, Rotation, Scale} from '@/ui/components/TitleAnimation/TitleAnimationScreenConfigs';

export const titleAnimationConfigLeft = (
  position: Position,
  scale: Scale,
  rotation: Rotation,
  frequency: number,
  texture: Texture[],
): EmitterConfigV3 =>
  upgradeConfig(
    {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: scale.start,
        end: scale.end,
        minimumScaleMultiplier: 1,
      },
      color: {
        start: '#ffffff',
        end: '#ffffff',
      },
      speed: {
        start: 150,
        end: 150,
        minimumSpeedMultiplier: 1,
      },
      acceleration: {
        x: 0,
        y: 0,
      },
      maxSpeed: 0,
      startRotation: {
        min: rotation.min,
        max: rotation.max,
      },
      noRotation: false,
      rotationSpeed: {
        min: -30,
        max: -30,
      },
      lifetime: {
        min: 7,
        max: 7,
      },
      blendMode: 'normal',
      frequency: frequency,
      emitterLifetime: -1,
      maxParticles: 5,
      pos: {
        x: position.x,
        y: position.y,
      },
      addAtBack: false,
      spawnType: 'circle',
      spawnCircle: {
        x: 0,
        y: 0,
        r: 0,
      },
    },
    texture,
  );

export const titleAnimationConfigRight = (
  position: Position,
  scale: Scale,
  rotation: Rotation,
  frequency: number,
  texture: Texture[],
): EmitterConfigV3 =>
  upgradeConfig(
    {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: scale.start,
        end: scale.end,
        minimumScaleMultiplier: 1,
      },
      color: {
        start: '#ffffff',
        end: '#ffffff',
      },
      speed: {
        start: 150,
        end: 150,
        minimumSpeedMultiplier: 1,
      },
      acceleration: {
        x: 0,
        y: 0,
      },
      maxSpeed: 0,
      startRotation: {
        min: rotation.min,
        max: rotation.max,
      },
      noRotation: false,
      rotationSpeed: {
        min: 50,
        max: 50,
      },
      lifetime: {
        min: 7,
        max: 7,
      },
      blendMode: 'normal',
      frequency: frequency,
      emitterLifetime: -1,
      maxParticles: 5,
      pos: {
        x: position.x,
        y: position.y,
      },
      addAtBack: false,
      spawnType: 'circle',
      spawnCircle: {
        x: 0,
        y: 0,
        r: 0,
      },
    },
    texture,
  );
